import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-primary-500"></i>;
    if (trend === 'new') return <i className="ri-sparkling-line text-accent-500"></i>;
    return null;
  };

  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-fire-line text-2xl text-primary-500"></i>
          </span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热播排行榜
          </h2>
        </div>
        <div className="space-y-2">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#media');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 p-4 bg-background-100 rounded-xl hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-bold text-sm font-heading ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-300 text-background-50' :
                item.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.category}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{item.heat}</span>
                <span className="w-4 h-4 flex items-center justify-center">
                  {trendIcon(item.trend)}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}